import React from "react"

import LinkedInIcon from "@material-ui/icons/LinkedIn"
import GitHubIcon from "@material-ui/icons/GitHub"

import "./style.scss"

const Footer = () => {
	return (
		<div className="footer">
			<div className="footer__container">
				<h4>Follow me on social media</h4>
				<div className="footer__social-icons">
					<a
						href="https://github.com/bytestefano"
						target="_blank"
						rel="noopener noreferrer">
						{" "}
						<GitHubIcon className="social-icon" />
					</a>
					<a
						href="https://www.linkedin.com/in/bytestefano/"
						target="_blank"
						rel="noopener noreferrer">
						<LinkedInIcon className="social-icon" />
					</a>
					<a
						href="https://www.behance.net/user/?username=bytestefano"
						target="_blank"
						rel="noopener noreferrer">
						<span className="social-icon">Be</span>
					</a>
					<a
						href="https://bytestefano.medium.com/"
						target="_blank"
						rel="noopener noreferrer">
						<span style={{fontSize: "20px"}}>Medium</span>
					</a>
				</div>
				<p>
					Built by bytestefano with React. Hosted on
					Netlify.
				</p>
				<p>Copyright © bytestefano {new Date().getFullYear()}</p>
			</div>
		</div>
	)
}

export default Footer
